import React from 'react';
import { KpiCard, KpiTone } from './KpiCard';

interface MetricCardProps {
  label: string;
  value: number | string;
  /** Legacy colour path; mapped to a tone. Prefer `tone`. */
  color?: string;
  tone?: KpiTone;
  loading?: boolean;
}

const toneFromColor = (color?: string): KpiTone => {
  if (!color) return 'none';
  if (color.startsWith('error')) return 'problem';
  if (color.startsWith('warning')) return 'caution';
  if (color.startsWith('success')) return 'positive';
  if (color.startsWith('info') || color.startsWith('primary')) return 'info';
  return 'none';
};

/** Kept for existing callers; renders a `KpiCard`. */
export const MetricCard: React.FC<MetricCardProps> = ({ label, value, color, tone, loading = false }) => (
  <KpiCard label={label} value={value} tone={tone ?? toneFromColor(color)} loading={loading} />
);
